'use strict';

var React = require('react');
var Reflux = require('reflux');

/* Mixins */
var AuthenticationMixin = require('mixins/authentication');

/* Router */
var Router = require('react-router');
var Navigation = Router.Navigation;

/* Stores */
var ProjectStore = require('stores/project');
var ModuleTypeStore = require('stores/module-type');
var ModuleInspectorStore = require('stores/module-inspector');
var TranslationEditorStore = require('stores/translation-editor');
var LanguageStore = require('stores/language');

/* Components */
var Panel = require('components/ui/panel');
var Modal = require('components/ui/modal');
var TextField = require('components/ui/text-field');
var ButtonGroup = require('components/ui/button-group');
var Button = require('components/ui/button');
var ProjectPlayground = require('./playground');
var SideBar = require('./sidebar');
var ModuleTypeList = require('./playground/module/list');
var Inspector = require('./playground/module/inspector');
var TranslationEditor = require('./translation-editor');
var Initials = require('components/user/initials');
var DateComponent = require('components/ui/date');

/* Actions */
var ProjectActions = require('actions/project');

var ProjectDetails = React.createClass({
  displayName: 'ProjectDetails',

  mixins: [AuthenticationMixin, Navigation, Reflux.connect(ProjectStore, 'projects'), Reflux.connect(ModuleTypeStore, 'moduleTypes'), Reflux.connect(ModuleInspectorStore, 'selectedModule'), Reflux.connect(TranslationEditorStore, 'translations')],

  getInitialState: function getInitialState() {
    return {
      name: ''
    };
  },

  componentDidMount: function componentDidMount() {
    var name = this.refs.name;

    if (name) {
      name.focus();
    }

    ProjectActions.loadAll();
  },

  componentWillUnmount: function componentWillUnmount() {
    ProjectActions.leave();
  },

  render: function render() {
    var component = this;

    var props = component.props;
    var state = component.state;
    var _onCreate = component._onCreate;
    var _onSubmit = component._onSubmit;
    var _onCancelEdit = component._onCancelEdit;
    var _onCancel = component._onCancel;
    var _onModuleTypeSelect = component._onModuleTypeSelect;
    var create = props.create;
    var params = props.params;

    if (create) {
      return React.createElement(
        'form',
        { className: 'details-component project-create-component', onSubmit: _onCreate },
        React.createElement(
          Panel,
          null,
          React.createElement(TextField, { ref: 'name', className: 'name-field', translationKey: 'project_details_name', value: state.name }),
          React.createElement(
            ButtonGroup,
            null,
            React.createElement(Button, { translationKey: 'cancel', className: 'cancel', onClick: component._onCancel }),
            React.createElement(Button, { translationKey: 'create', type: 'submit' })
          )
        )
      );
    }

    if (!params.projectId) {
      return React.createElement(
        'form',
        { className: 'details-component project-missing-component', onSubmit: _onCancel },
        React.createElement(
          Panel,
          null,
          'No project with matching ID',
          React.createElement(
            ButtonGroup,
            null,
            React.createElement(Button, { translationKey: 'back', type: 'submit' })
          )
        )
      );
    }

    var project = state.projects.find(function (project) {
      return project.id === params.projectId;
    });

    if (!project) {
      return null;
    }

    var sidebarContentNodes = [];

    if (state.selectedModule) {
      sidebarContentNodes.push(React.createElement(Inspector, { key: 'inspector', name: 'inspector', selectedModule: state.selectedModule, projectId: params.projectId }));
    } else {
      var createdInfoNode = null;

      if (project.createdBy) {
        createdInfoNode = React.createElement(
          'div',
          { className: 'creation-info' },
          'Created by ',
          React.createElement(
            Initials,
            null,
            project.createdBy
          ),
          ' on ',
          React.createElement(
            DateComponent,
            null,
            new Date(project.createdAt)
          )
        );
      }

      sidebarContentNodes.push(React.createElement(
        'div',
        { key: 'header', name: 'header' },
        React.createElement(
          'div',
          { className: 'project-name link', onClick: component._onEdit },
          React.createElement(
            'div',
            { className: 'edit' },
            React.createElement('li', { className: 'fa fa-pencil' })
          ),
          React.createElement(
            'div',
            { className: 'title' },
            project.name
          )
        ),
        createdInfoNode
      ), React.createElement(ModuleTypeList, { key: 'modules', name: 'modules', moduleTypes: state.moduleTypes, onSelect: _onModuleTypeSelect }));
    }

    var translationEditor = null;
    if (TranslationEditorStore.open) {
      translationEditor = React.createElement(TranslationEditor, {
        translations: state.translations,
        selectedTranslation: TranslationEditorStore.selectedTranslation });
    }

    var editView = null;
    var copyView = null;

    if (component.state.copy) {
      copyView = React.createElement(
        Modal,
        { className: 'project-modal-component project-copy-component', onCancel: component._onCancelCopy },
        React.createElement(TextField, { ref: 'copyName', className: 'name-field', translationKey: 'project_details_copy_name', value: project.name + ' copy' }),
        React.createElement(
          ButtonGroup,
          null,
          React.createElement(Button, { translationKey: 'project_details_copy_submit', className: 'submit', onClick: component._onSubmitCopy }),
          React.createElement(Button, { translationKey: 'cancel', className: 'cancel', onClick: component._onCancelCopy })
        )
      );
    } else if (component.state.edit) {
      editView = React.createElement(
        Modal,
        { className: 'project-modal-component project-edit-component', onCancel: component._onCancelEdit },
        React.createElement(TextField, { ref: 'name', className: 'name-field', translationKey: 'project_details_name', value: project.name }),
        React.createElement(
          ButtonGroup,
          null,
          React.createElement(Button, { translationKey: 'cancel', className: 'cancel', onClick: component._onCancelEdit }),
          React.createElement(Button, { translationKey: 'project_details_copy', className: 'copy', onClick: component._onCopy }),
          React.createElement(Button, { translationKey: 'save', className: 'submit', onClick: component._onSubmit }),
          React.createElement(Button, { translationKey: 'delete', className: 'delete', onClick: component._onDelete })
        )
      );
    }

    return React.createElement(
      'div',
      { className: 'project-details-component' },
      editView,
      copyView,
      translationEditor,
      React.createElement(ProjectPlayground, project),
      React.createElement(SideBar, { content: sidebarContentNodes })
    );
  },

  _onModuleTypeSelect: function _onModuleTypeSelect(moduleTypeId) {
    var component = this;
    var props = component.props;
    var params = props.params;
    var projectId = params.projectId;

    ProjectActions.addModule(projectId, moduleTypeId);
  },

  _onCancel: function _onCancel(evt) {
    if (evt) {
      evt.preventDefault();
    }

    var component = this;

    component.transitionTo('/');
  },

  _onCancelEdit: function _onCancelEdit() {
    this.setState({ edit: false });
  },

  _onCreate: function _onCreate(evt) {
    evt.preventDefault();

    var name = this.refs.name.value;

    ProjectActions.create({ name: name });

    this.transitionTo('/');
  },

  _onEdit: function _onEdit() {
    this.setState({ edit: true });
  },

  _onSubmit: function _onSubmit() {
    var props = this.props;
    var refs = this.refs;

    var id = props.params.projectId;
    var name = refs.name.value;

    ProjectActions.edit(id, { name: name });
    this.setState({ edit: false });
  },

  _onDelete: function _onDelete() {
    if (confirm(LanguageStore.translate('project_details_delete_confirmation'))) {
      ProjectActions['delete'](this.props.params.projectId);
    }
  },

  _onCopy: function _onCopy() {
    this.setState({ copy: true });
  },

  _onCancelCopy: function _onCancelCopy() {
    this.setState({ copy: false });
  },

  _onSubmitCopy: function _onSubmitCopy() {
    if (confirm(LanguageStore.translate('project_details_copy_confirmation'))) {
      var _name = this.refs.copyName.value;
      this.setState({ copy: false, edit: false });
      ProjectActions.copy(this.props.params.projectId, { name: _name });
    }
  }
});

module.exports = ProjectDetails;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/details.js
 **/